<template>
  <div class="audio-time-ind">
    <time class="audio-time-ind__current">{{ currentTime }}</time>
    <time class="audio-time-ind__duration">{{ durationTime }}</time>
    <time v-if="adjustedRemainingTime" class="audio-time-ind__remaining">{{ adjustedRemainingTime }}</time>
  </div>
</template>

<script setup>
  const props = defineProps({
    //Текущее время
    currentTime: { type: String },
    //Длительность аудио
    durationTime: { type: String },
    //Реальное оставшееся время с учётом скорости
    adjustedRemainingTime: { type: String, default: null }
  });
</script>

<style lang="scss" scoped>
  @import'./styles';
</style>